import { html } from '@dom'

function component() {
  return html`
    <slot></slot>
  `
}

export default component
